module.exports = __webpack_public_path__ + "assets/images/spinner.fa87c82be50e62cb1f160e05871775bb.svg";